import * as React from "react";

interface IProps {
  date: Date | string;
}

class FormattedDate extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  public shouldComponentUpdate(nextProps: IProps) {
    return this.props.date !== nextProps.date;
  }

  public render() {
    let objDate;

    if (this.props.date instanceof Date) {
      objDate = this.props.date;
    } else {
      objDate = new Date(this.props.date);
    }

    return (
      <span className="date">
        {new Intl.DateTimeFormat("en-US", {
          // tslint:disable-next-line
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          // tslint:disable-next-line
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: false
        }).format(new Date(objDate))}
      </span>
    );
  }
}

export default FormattedDate;



// WEBPACK FOOTER //
// ./src/components/FormattedDate/index.tsx